import { ChangeDetectorRef, Component, HostListener, ChangeDetectionStrategy, inject } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterModule, RouterOutlet} from '@angular/router';
import {AuthService} from './Services/auth.service';

import {EnvLoader} from './Environment/EnvLoader';
import {NavigationHeaderComponent} from "./Components/NavigationHeader/navigation-header.component";
import {TranslateService} from '@ngx-translate/core';
import {InformationsBandModuleComponent} from './Components/InformationsBand/InformationsBandModule.component';
import {QdmService} from './Services/qdm.service';
import {ResponsiveService} from "./Services/responsive.service";
import {CookieService} from "ngx-cookie-service";

@Component({
    selector: 'app-root',
    imports: [
    RouterModule,
    RouterOutlet,
    NavigationHeaderComponent,
    InformationsBandModuleComponent
],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
  router = inject(Router);
  currentRoute = inject(ActivatedRoute);
  private auth = inject(AuthService);
  private translate = inject(TranslateService);
  private gestion = inject(QdmService);
  private qdm = inject(QdmService);
  private cookie = inject(CookieService);
  private cdr = inject(ChangeDetectorRef);
  private responsive = inject(ResponsiveService);

  needToShowCookies: boolean = false;
  onErrorPage: boolean = false;

  ngOnInit() {
    this.needToShowCookies = !this.cookie.check("cookies-compliance");
    
    this.cdr.detectChanges();

    if (!(globalThis as any).env) {
      EnvLoader.load();
    }

    this.translate.setDefaultLang("fr");

    (window as any).dd = () => {
      console.clear();
      this.auth.printAll();
      this.qdm.printAll();
    };

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(event.url.startsWith("/error")) {
          this.onErrorPage = true;
          this.cdr.detectChanges();
        }else{
          this.onErrorPage = false;
          this.cdr.detectChanges();
        }
      }
    });
    this.onWindowResized();
  }

  @HostListener('window:resize')
  onWindowResized() {
    const {innerWidth} = window;

    if (innerWidth > 768) {
      if (this.responsive.isMobileCartShowedSubject.value) {
        this.responsive.isMobileCartShowedSubject.next(false);
      }
    }
  }

  complyWithCookies() {
    this.cookie.set("cookies-compliance", "true", 365, "/");
    this.needToShowCookies = false;
    this.cdr.detectChanges();
  }
}

